import SolicitudMontoService from "@/api/services/finanzas/SolicitudMontoService"
import Vue from "vue"

const state = () => ({
    statsTab1Sec1: {},
    statsTab2Sec1: {},
    statsTab2Sec2: {},
    statsTab3Sec1: {},
    statsTab3Sec2: {},
    statsTab3Sec3: {},
    statsTab3Sec4: {}
})

const getters = {
    //tab1
    MONTOS_TAB1_SEC1: state => {
        return state.statsTab1Sec1
    },

    //tab2
    MONTOS_TAB2_SEC1: state => {
        return state.statsTab2Sec1
    },

    MONTOS_TAB2_SEC2: state => {
        return state.statsTab2Sec2
    },

    //tab3
    MONTOS_TAB3_SEC1: state => {
        return state.statsTab3Sec1
    },

    MONTOS_TAB3_SEC2: state => {
        return state.statsTab3Sec2
    },

    MONTOS_TAB3_SEC3: state => {
        return state.statsTab3Sec3
    },

    MONTOS_TAB3_SEC4: state => {
        return state.statsTab3Sec4
    }
}

const mutations = {
    SET_SOLICITUDES_MONTOS: (state, payload) => {
        const cols = ["nombre", "valor"]
        let data = payload.data
        switch (payload.tabSectionQuery) {
            case "Tab1Section1":
                state.statsTab1Sec1 = { cols, data }
                break
            case "Tab2Section1":
                state.statsTab2Sec1 = { cols, data }
                break
            case "Tab2Section2":
                state.statsTab2Sec2 = { cols, data }
                break
            case "Tab3Section1":
                state.statsTab3Sec1 = { cols, data }
                break
            case "Tab3Section2":
                state.statsTab3Sec2 = { cols, data }
                break
            case "Tab3Section3":
                state.statsTab3Sec3 = { cols, data }
                break
            case "Tab3Section4":
                state.statsTab3Sec4 = { cols, data }
                break
        }
    }
}

const actions = {
    LOAD_SOLICITUDES_MONTOS: async ({ commit }, { customfilter, tabSectionQuery }) => {
        try {
            let { data, status } = await SolicitudMontoService.getMontosTotal(customfilter)
            if (status === 200) {
                commit("SET_SOLICITUDES_MONTOS", { data, tabSectionQuery })
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los valores de los montos solicitados"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
